const PRIMARY_KEY = 'TEST_PREVIEW_';

export const TEST_PREVIEW_OVERVIEW = PRIMARY_KEY + 'OVERVIEW';
export const TEST_PREVIEW_QUESTIONS = PRIMARY_KEY + 'QUESTIONS';
export const TEST_PREVIEW_CONSTRAINTS = PRIMARY_KEY + 'CONSTRAINTS';
export const TEST_PREVIEW_CHAPTERS = PRIMARY_KEY + 'CHAPTERS';
export const TEST_PREVIEW_RESET = PRIMARY_KEY + 'RESET';
